import { NgModule } from '@angular/core';
import { SubmissionDetailsSharedModule } from '../../shared/submission-details-shared.module';
import { FormDetailsBaseViewComponent } from './shared/form-details-base-view/form-details-base-view.component';
import { IncompleteFormComponent } from './features/incomplete-form/incomplete-form.component';
import { NewFormComponent } from './features/new-form/new-form.component';
import { FormDetailsSectionComponent } from './shared/form-details-section/form-details-section.component';
import { BusinessFormComponent } from './shared/business-form/business-form.component';
import { AddressFormComponent } from './shared/address-form/address-form.component';
import { OwnerInformationFormComponent } from './shared/owner-information-form/owner-information-form.component';
import { FormDetailsActionsService } from './services/actions/form-details-actions.service';
import { FormDetailsSectionHeaderComponent } from './shared/form-details-section-header/form-details-section-header.component';
import { DocumentsSectionComponent } from './shared/documents-section/documents-section.component';

@NgModule({
  imports: [SubmissionDetailsSharedModule],
  declarations: [
    NewFormComponent,
    IncompleteFormComponent,
    FormDetailsBaseViewComponent,
    FormDetailsSectionComponent,
    BusinessFormComponent,
    AddressFormComponent,
    OwnerInformationFormComponent,
    DocumentsSectionComponent,
    FormDetailsSectionHeaderComponent,
  ],
  exports: [NewFormComponent, IncompleteFormComponent],
  providers: [FormDetailsActionsService],
})
export class FormDetailsModule {}
